import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

export const startStudentExam = createAsyncThunk('startStudentExam', async ({ exam_id, navigate }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + `student_exam`,
            data: { exam_id },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const startStudentExamSlice = createSlice({
    name: 'startStudentExam',
    initialState: { data: null },
    extraReducers: (builder) => {
        builder.addCase(startStudentExam.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
    }
})

export default startStudentExamSlice.reducer;
